import {
  Avatar,
  AvatarUser,
  Column,
  FlexBox,
  Text,
} from '@dixa/lib-shared-habla';
import { ReactNode } from 'react';

import {
  ContactItems,
  ContactItemsProps,
} from './components/contactItems/contactItems';
import styles from './contactInfo.module.scss';

type ContactInfoProps = {
  avatar: AvatarUser;
  primaryLabel: ReactNode;
  secondaryLabel?: ReactNode;
  contactItemSections?: ContactItemsProps[];
  actions?: ReactNode;
};

export function ContactInfo({
  avatar,
  primaryLabel,
  secondaryLabel,
  contactItemSections,
  actions,
}: ContactInfoProps): JSX.Element {
  return (
    <Column className={styles.root}>
      <Column.Row slottable noHorizontalPadding>
        <Column.Slot placement="start">
          <FlexBox gap="300" alignItems="center">
            <Avatar user={avatar} size="40" />

            <FlexBox flexDirection="column" gap="100">
              <Text.Heading>{primaryLabel}</Text.Heading>

              {secondaryLabel && (
                <FlexBox alignItems="center">{secondaryLabel}</FlexBox>
              )}
            </FlexBox>
          </FlexBox>
        </Column.Slot>

        {actions && (
          <Column.Slot placement="end">
            <FlexBox alignItems="center">{actions}</FlexBox>
          </Column.Slot>
        )}
      </Column.Row>

      {contactItemSections?.length ? (
        <Column.Row
          className={styles.sections}
          noHorizontalPadding
          noVerticalPadding
        >
          {contactItemSections?.map((section, index) => (
            <ContactItems
              key={index}
              isLast={index < contactItemSections.length - 1}
              {...section}
            />
          ))}
        </Column.Row>
      ) : null}
    </Column>
  );
}
